import { ReactElement } from 'react';
import AuthenticatedRoute from '../../components/AuthenticatedRoute';
import Header from '../../components/Header';
import { Outlet } from 'react-router';
import { TenantSettingsGate } from '../gates/TenantSettingsGate';
import { ChatProvider } from '../../contexts/chat-context';

export const AuthenticatedLayout = (): ReactElement => {
  return (
    <AuthenticatedRoute>
      <TenantSettingsGate>
        <ChatProvider>
          <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
            <Header />
            <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflow: 'auto' }}>
              <Outlet />
            </div>
          </div>
        </ChatProvider>
      </TenantSettingsGate>
    </AuthenticatedRoute>
  );
};
